import { render, staticRenderFns } from "./ProductFamily.vue?vue&type=template&id=338a94e0&scoped=true"
import script from "./ProductFamily.vue?vue&type=script&lang=js"
export * from "./ProductFamily.vue?vue&type=script&lang=js"
import style0 from "./ProductFamily.vue?vue&type=style&index=0&id=338a94e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338a94e0",
  null
  
)

export default component.exports